import Project from 'src/entities/Project';
import Person from 'src/entities/Person';
import * as moment from 'moment';
import { Moment } from 'moment';

export default class Investment {
  id?: number;
  project?: Project;
  person?: Person;
  quantityTickets: number;
  tcaRepresentative: boolean;
  termsAndConditions?: boolean;
  acceptsCommitment?: boolean;
  status?: string;
  acceptedShareholderAgreement?: boolean;
  acceptedSyndicateAgreement?: boolean;
  signedShareholderAgreement?: boolean;
  signedSyndicateAgreement?: boolean;
  fees: number;
  amountInvested: number;
  actualPrice?: number;
  createdAt?: Moment;
  dueDiligenceStatus?: string;
  isPaid?: boolean;
  essentialAsset?: boolean;

  constructor(entity: Investment) {
    this.id = entity.id || undefined;
    this.project = entity.project ? new Project(entity.project) : undefined;
    this.person = entity.person ? new Person(entity.person) : undefined;
    this.quantityTickets = entity.quantityTickets;
    this.tcaRepresentative = entity.tcaRepresentative;
    this.termsAndConditions = entity.termsAndConditions;
    this.acceptsCommitment = entity.acceptsCommitment;
    this.status = entity.status;
    this.acceptedShareholderAgreement = entity.acceptedShareholderAgreement;
    this.acceptedSyndicateAgreement = entity.acceptedSyndicateAgreement;
    this.signedShareholderAgreement = entity.signedShareholderAgreement;
    this.signedSyndicateAgreement = entity.signedSyndicateAgreement;
    this.fees = entity.fees;
    this.amountInvested = entity.amountInvested;
    this.actualPrice = entity.actualPrice || undefined;
    this.createdAt = moment(entity.createdAt) || undefined;
    this.dueDiligenceStatus = entity.dueDiligenceStatus;
    this.isPaid = entity.isPaid || false;
    this.essentialAsset = entity.essentialAsset || undefined;
  }
}



// WEBPACK FOOTER //
// ./src/entities/Investment.tsx